import { all, delay, fork, put, takeEvery, call, select } from '../../shared/SagaService';
import {push} from 'react-router-redux';
import {message} from 'antd';
import Cookies from 'universal-cookie';
import actions from './actions';
import AppActions from '../App/actions';
import NotificationActions from '../Notification/actions';
import LoggerActions from '../Logger/actions';
import AccountActions from '../Account/actions';
import SubscriptionActions from '../Subscription/actions';
import {get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";
import dayjs from 'dayjs';
import { MomentFormatEnums } from '../../enums/MomentEnums';
import { SessionExpiredMessage } from '../../components/Message/SessionExpired.js';
import { cleanSessionTimeoutCookies } from '../../containers/App/SessionTimeoutTimer';
import { CookiesHelper } from '../../helpers/CookiesHelper';
import { CookieKey } from '../../enums/CookieKey';
import { isSessionExpiredDebug } from '../../components/Modal/SessionExpiredModal';
import {
    IDLE_TIMEOUT_DURATION,
    IDLE_TIMEOUT_TIME_UNIT,
} from '../../components/Modal/SessionInactiveModalV2/constants';
import {
    getDummyFinancingCompany, useDummyFinancingCompany,

} from '../../containers/AppPage/Financing/utils/dummy';
import { dummyAccess, useDummyAccess } from './dummyPermissions';

const COOKIE_EXPIRY_REMEMBER = isSessionExpiredDebug ? 30 : 7;
const COOKIE_EXPIRY_NO_REMEMBER = isSessionExpiredDebug ? 10 : 1;
const COOKIE_EXPIRY_TIME_UNIT = isSessionExpiredDebug ? 'seconds' : 'day';

// Register
export function* registerRequest() {
    yield takeEvery(actions.REGISTER_REQUEST, function* ({ payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/auth/register', payload, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.REGISTER_SUCCESS,
                accessToken: data.access_token,
                subdomain: payload.subdomain,
                data,
                remember: true, // Decide for user
            });
        }
        catch (error) {
            yield put({
                type: actions.REGISTER_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* registerSuccess() {
    yield takeEvery(actions.REGISTER_SUCCESS, function* (payload) {
        const urlMode = process.env.REACT_APP_URL_MODE;
        yield put({
            type: actions.LOGIN_SUCCESS,
            accessToken: payload.accessToken,
            subdomain: payload.subdomain,
            remember: payload.remember,
            data: payload.data,
            urlMode,
        });
    });
}
export function* registerError() {
    yield takeEvery(actions.REGISTER_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Activate
export function* sendActivationCodeRequest() {
    yield takeEvery(actions.SEND_ACTIVATION_CODE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/auth/activation_code', request, context);

            // OK
            yield put({
                type: actions.SEND_ACTIVATION_CODE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.SEND_ACTIVATION_CODE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* sendActivationCodeSuccess() {
    yield takeEvery(actions.SEND_ACTIVATION_CODE_SUCCESS, function* () {
        yield message.success(t`Activation code sent to email.`);
    });
}
export function* sendActivationCodeError() {
    yield takeEvery(actions.SEND_ACTIVATION_CODE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Activate
export function* activateRequest() {
    yield takeEvery(actions.ACTIVATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/auth/activate', request, context);
            const { access, company, user } = yield response.data;

            // OK
            yield put({
                type: actions.ACTIVATE_SUCCESS,
            });
            yield put({
                type: actions.VALIDATE_SESSION_SUCCESS,
                access,
                company,
                user,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACTIVATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* activateError() {
    yield takeEvery(actions.ACTIVATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Login
export function* loginRequest() {
    yield takeEvery([
        actions.LOGIN_REQUEST,
    ], function* ({payload, type}, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/auth/login', payload, context);
            const data = yield response.data;

            // OK
            const urlMode = process.env.REACT_APP_URL_MODE;
            yield put({
                type: type.replace('REQUEST', "SUCCESS"),
                accessToken: data.access_token,
                email: payload.email,
                subdomain: payload.subdomain,
                remember: payload.remember,
                data,
                urlMode,
            });
        }
        catch (error) {
            yield put({
                type: type.replace('REQUEST', "ERROR"),
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* loginSuccess() {
    yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
        const urlMode = process.env.REACT_APP_URL_MODE;
        const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;
        const { setCookies } = CookiesHelper;

        // remember = 7 days
        // no remember = 1 day
        const expiryDays = payload.remember ? COOKIE_EXPIRY_REMEMBER : COOKIE_EXPIRY_NO_REMEMBER;
        const expiryMoment = dayjs().add(expiryDays, COOKIE_EXPIRY_TIME_UNIT);
        const expiryDate = expiryMoment.toDate();

        // Set cookies
        yield setCookies(`${cookiePrefix}at`, payload.accessToken, null, expiryDate);

        if (urlMode === 'single')
            yield setCookies(`${cookiePrefix}cs`, payload.subdomain, null, expiryDate);

        setCookies(CookieKey.session_expiry,
            expiryMoment.format(MomentFormatEnums.date_time),
            null,
            expiryDate,
        );

        setCookies(CookieKey.remember_me, payload.remember, null, expiryDate);
        setCookies(
            CookieKey.session_idle, // SessionInactiveModalV2 (2 hour)
            dayjs().add(IDLE_TIMEOUT_DURATION, IDLE_TIMEOUT_TIME_UNIT).format(MomentFormatEnums.date_time),
            null,
            expiryDate,
        );

        setCookies(CookieKey.last_logged_in_cs, payload.subdomain, expiryDays, null, expiryDate);
        setCookies(CookieKey.last_logged_in_email, payload.email, expiryDays, null, expiryDate);

        // if there is a session timeout message, close it
        const expiredWarning = new SessionExpiredMessage();
        expiredWarning.destroy();
    });
}
export function* loginError() {
    yield takeEvery([
        actions.LOGIN_ERROR,
    ], function* ({ error }) {
        yield message.error(error.message);
    });
}

// VALIDATE SESSION - WHEN INACTIVE
export function* reauthenticateRequest() {
    yield takeEvery([
        actions.REAUTHENTICATE_REQUEST,
    ], function* ({payload, type}, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/auth/check', payload, context);
            const data = yield response.data;

            // OK
            yield put({
                type: type.replace('REQUEST', "SUCCESS"),
            });
            yield put({
                type: actions.REAUTHENTICATE_SUCCESS,
                accessToken: data.access_token,
                remember: false,
            });
        }
        catch (error) {
            yield put({
                type: type.replace('REQUEST', "ERROR"),
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* reauthenticateSuccess() {
    yield takeEvery(actions.REAUTHENTICATE_SUCCESS, function* () {
        // yield put({
        //     type: AppActions.CLOSE_APP_MODAL,
        // });
    });
}
export function* reauthenticateError() {
    yield takeEvery([
        actions.REAUTHENTICATE_ERROR,
    ], function* ({ error }) {
        yield message.error(error.message);
    });
}

// Reset token
export function* resetTokenRequest() {
    yield takeEvery(actions.RESET_TOKEN_REQUEST, function* ({ payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(get, '/auth/reset_token', payload, context);

            // OK
            yield put({
                type: actions.RESET_TOKEN_SUCCESS,
                resetPasswordEmail: payload.email,
            });
        }
        catch (error) {
            yield put({
                type: actions.RESET_TOKEN_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* resetTokenSuccess() {
    yield takeEvery(actions.RESET_TOKEN_SUCCESS, () => {});
}
export function* resetTokenError() {
    yield takeEvery(actions.RESET_TOKEN_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Reset password
export function* resetPasswordRequest() {
    yield takeEvery(actions.RESET_PASSWORD_REQUEST, function* ({ payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/auth/reset_password', payload, context);

            // OK
            yield put({
                type: actions.RESET_PASSWORD_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.RESET_PASSWORD_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* resetPasswordSuccess() {
    yield takeEvery(actions.RESET_PASSWORD_SUCCESS, function* () {
        yield put({
            type: actions.RESET_PASSWORD_HIDE,
        });
        yield put(push('/signin'));
        yield message.success(t`Your password has been reset, please login with your new password.`);
    });
}
export function* resetPasswordError() {
    yield takeEvery(actions.RESET_PASSWORD_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Check locally if user is logged in
export function* checkAuthorization() {
    yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
        const cookies = new Cookies();
        const urlMode = process.env.REACT_APP_URL_MODE;
        const urlDomain = process.env.REACT_APP_URL_DOMAIN;
        const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;
        const {hostname} = window.location;
        const accessToken = cookies.get(`${cookiePrefix}at`);
        let subdomain = cookies.get(`${cookiePrefix}cs`);

        if (accessToken) {
            if (!subdomain && urlMode === 'subdomain') // Read subdomain from URL
                subdomain = hostname.substr(0, hostname.indexOf(urlDomain) - 1);

            yield put({
                type: actions.CHECK_AUTHORIZATION_SUCCESS,
                accessToken,
                subdomain,
                urlMode,
            });
        }
    });
}

// Validate session
export function* validateSessionRequest() {
    yield takeEvery(actions.VALIDATE_SESSION_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/auth/validate', null, context);
            const { access, company, user, apps } = yield response.data;

            // OK
            yield put({
                type: actions.VALIDATE_SESSION_SUCCESS,
                access: useDummyAccess ? dummyAccess : access,
                company: useDummyFinancingCompany ? getDummyFinancingCompany(company) : company,
                user,
                apps,
            });

            yield delay(800);
            yield put({
                type: actions.SET_SESSION_READY,
            });
        }
        catch (error) {
            console.error(error);
            yield put({
                type: actions.VALIDATE_SESSION_ERROR,
                error,
            });
        }
    });
}
export function* validateSessionSuccess() {
    yield takeEvery(actions.VALIDATE_SESSION_SUCCESS, function* ({user, company}) {
        const { setCookies } = CookiesHelper;

        const isRemember = yield select(state => state.Auth.remember);

        // remember = 7 days
        // no remember = 1 day
        const expiryDays = isRemember ? 7 : 1;

        const { subdomain } = company;
        const { email } = user;

        // Set cookies
        setCookies(CookieKey.last_logged_in_cs, subdomain, expiryDays);
        setCookies(CookieKey.last_logged_in_email, email, expiryDays);

        yield put({
            type: AccountActions.ACCOUNT_SET_SYSTEM_TYPES_BY_INVENTORY_SYSTEM,
            inventory_system: company.inventory_system, // whether to filter out stock movement system accounts
        });

        yield put({
            type: SubscriptionActions.SUBSCRIPTION_READ_SUCCESS,
            subscription: company.subscription, // whether to filter out stock movement system accounts
        });
    });
}

export function* validateSessionError() {
    yield takeEvery(actions.VALIDATE_SESSION_ERROR, ({ error }) => {
        switch (error.statusCode) {
            case 403: // Unauthorised
            case 503: // Service unavailable (when company running migration)
                // message could be:
                // "The company account does not exist."
                message.warning(error.message);
                // yield put(push('/signin'));
                break;
            case 401:
            default:
                // message.warning(t`Session is time out, please login again.`);
                // yield put(push('/signin'));
                break;
        }
    });
}

// Invite
export function* readInviteRequest() {
    yield takeEvery('READ_INVITE_REQUEST', function* ({ payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/auth/invite', payload, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_INVITE_SUCCESS,
                user: data.user,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_INVITE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readInviteSuccess() {
    yield takeEvery(actions.READ_INVITE_SUCCESS, () => {});
}
export function* readInviteError() {
    yield takeEvery(actions.READ_INVITE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Accept invite
export function* acceptInviteRequest() {
    yield takeEvery(actions.ACCEPT_INVITE_REQUEST, function* ({ payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, '/auth/invite', payload, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ACCEPT_INVITE_SUCCESS,
                accessToken: data.access_token,
                subdomain: data.company_subdomain,
                data,
                remember: true, // Decide for user
            });
        }
        catch (error) {
            yield put({
                type: actions.ACCEPT_INVITE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* acceptInviteSuccess() {
    yield takeEvery(actions.ACCEPT_INVITE_SUCCESS, function* (payload) {
        const urlMode = process.env.REACT_APP_URL_MODE;
        yield put({
            type: actions.LOGIN_SUCCESS,
            accessToken: payload.accessToken,
            subdomain: payload.subdomain,
            remember: payload.remember,
            data: payload.data,
            urlMode,
        });
    });
}
export function* acceptInviteError() {
    yield takeEvery(actions.ACCEPT_INVITE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* readAccountSetsRequest() {
    yield takeEvery(actions.READ_ACCOUNT_SETS_REQUEST, function* () {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/auth/account_sets');
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_ACCOUNT_SETS_SUCCESS,
                accountSets: data,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_ACCOUNT_SETS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    },
    );
}
export function* readAccountSetsSuccess() {
    yield takeEvery(actions.READ_ACCOUNT_SETS_SUCCESS, () => {});
}
export function* readAccountSetsError() {
    yield takeEvery(actions.READ_ACCOUNT_SETS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Boot Intercom with identity verification JWT
export function* bootIntercomRequest() {
    yield takeEvery(actions.BOOT_INTERCOM_REQUEST, function* ({ payload }) {
        try {
            const response = yield call(get, '/auth/intercom_token');
            const { token } = yield response.data;
            console.log('[Intercom] JWT token:', token); // TODO: remove after validation

            yield put({ type: actions.BOOT_INTERCOM_SUCCESS });

            window.Intercom('boot', {
                app_id: 'ezxzuetg',
                email: payload.user.email,
                user_id: payload.user.id,
                name: payload.user.first_name,
                intercom_user_jwt: token,
                company: {
                    id: payload.company.id,
                    name: payload.company.subdomain,
                },
            });
        }
        catch (error) {
            yield put({ type: actions.BOOT_INTERCOM_ERROR, error });
        }
    });
}

// Logout
export function* logout() {
    yield takeEvery(actions.LOGOUT, function* () {
        const urlMode = process.env.REACT_APP_URL_MODE;
        const urlDomain = process.env.REACT_APP_URL_DOMAIN;
        const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;
        const cookies = new Cookies();
        const options = {};

        options.path = '/';
        if (urlMode === 'subdomain')
            options.domain = `.${urlDomain}`;

        cookies.remove(`${cookiePrefix}at`, options);
        cookies.remove(`${cookiePrefix}cs`, options);

        cleanSessionTimeoutCookies();

        yield put(push('/signin'));
        yield put(NotificationActions.resetNotification());
        yield put({type: LoggerActions.LOGGER_RESET_STATE});
        yield put({type: AppActions.CLOSE_ALL_APP_MODALS});
    });
}

export default function* rootSaga() {
    yield all([
        fork(registerRequest),
        fork(registerSuccess),
        fork(registerError),
        fork(activateRequest),
        fork(activateError),
        fork(sendActivationCodeRequest),
        fork(sendActivationCodeSuccess),
        fork(sendActivationCodeError),
        fork(loginRequest),
        fork(loginSuccess),
        fork(loginError),
        fork(reauthenticateRequest),
        fork(reauthenticateSuccess),
        fork(reauthenticateError),
        fork(resetTokenRequest),
        fork(resetTokenSuccess),
        fork(resetTokenError),
        fork(resetPasswordRequest),
        fork(resetPasswordSuccess),
        fork(resetPasswordError),
        fork(checkAuthorization),
        fork(validateSessionRequest),
        fork(validateSessionSuccess),
        fork(validateSessionError),
        fork(readInviteRequest),
        fork(readInviteSuccess),
        fork(readInviteError),
        fork(acceptInviteRequest),
        fork(acceptInviteSuccess),
        fork(acceptInviteError),
        fork(logout),
        fork(readAccountSetsRequest),
        fork(bootIntercomRequest),
    ]);
}
